import { Eye } from 'react-feather'
import { RouterPreference } from 'state/routing/slice'
import { useRouterPreference } from 'state/user/hooks'
import styled, { css, keyframes } from 'styled-components/macro'
import { ThemedText } from 'theme'

const shimmerAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

const RouteIcon = styled(Eye)<{ open?: boolean }>`
  vertical-align: middle;
`

const ClickableRouterLabel = styled.div<{ $syncing?: boolean }>`
  cursor: pointer;
  padding-right: 0.5px;
  display: inline-block;

  ${({ $syncing, theme }) =>
    $syncing &&
    css`
      animation: ${shimmerAnimation} 1.5s infinite;
      animation-fill-mode: both;
      background: linear-gradient(
        to left,
        ${theme.textPrimary} 25%,
        ${theme.textTertiary} 50%,
        ${theme.textPrimary} 75%
      );
      background-size: 400%;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      will-change: background-position;

      svg {
        stroke: ${theme.textTertiary};
      }
    `}
`

export default function RouterLabel({ syncing = false }: { syncing?: boolean }) {
  const [routerPreference] = useRouterPreference()

  switch (routerPreference) {
    case RouterPreference.AUTO:
    case RouterPreference.API:
      return (
        <ClickableRouterLabel $syncing={syncing}>
          <ThemedText.BodySmall fontWeight={600} fontSize="13px">
            Preview Route <RouteIcon width="12px" height="12px" />
          </ThemedText.BodySmall>
        </ClickableRouterLabel>
      )
    case RouterPreference.CLIENT:
      return <ThemedText.BodySmall>Piteas Client</ThemedText.BodySmall>
  }
}

export function RouterLabelX() {
  const [routerPreference] = useRouterPreference()

  switch (routerPreference) {
    case RouterPreference.AUTO:
    case RouterPreference.API:
      return (
        <ThemedText.BodySmall color="textSecondary" fontWeight={600} fontSize="13px">
          Route Details{' '}
        </ThemedText.BodySmall>
      )
    case RouterPreference.CLIENT:
      return <ThemedText.BodySmall>Piteas Client</ThemedText.BodySmall>
  }
}
